export default function blockInitialTransition() {
  return function link($scope, $element) {
    $element.addClass('transition-none');

    $scope.$$postDigest(() => {
      $element.removeClass('transition-none');
    });
  };
}
